import { ReactElement } from 'react';

interface TableSkeletonProps {
  columns: number;
  rows?: number;
}

export default function TableSkeleton({ columns, rows = 5 }: TableSkeletonProps): ReactElement {
  return (
    <div className="cr-mb-8 cr-overflow-x-auto">
      <table className="cr-min-w-full cr-border-separate cr-border-spacing-0 cr-rounded-b-lg cr-rounded-t-lg cr-border-2 cr-border-solid cr-border-cirrusBlue-100 cr-bg-cirrusBlue-25 cr-font-main cr-text-xs md:cr-text-sm">
        <thead>
          <tr className="cr-rounded-t-lg cr-border-2 cr-border-solid cr-border-cirrusBlue-100 cr-bg-cirrusBlue-50 cr-p-3 cr-font-main cr-text-sm cr-text-black md:cr-text-base">
            {Array.from({ length: columns }).map((_, index) => {
              const isFirstCell = index === 0;
              const isLastCell = index === columns - 1;
              let thClass =
                'cr-px-3 cr-py-2 cr-text-left cr-text-black cr-border-0 cr-border-b-2 cr-border-cirrusBlue-100 cr-border-solid';
              if (isFirstCell) thClass += ' cr-rounded-tl-lg';
              if (isLastCell) thClass += ' cr-rounded-tr-lg';

              return (
                <th key={index} className={thClass}>
                  <div className="cr-h-4 cr-w-20 cr-animate-pulse cr-rounded cr-bg-gray-200"></div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr
              key={rowIndex}
              className={`cr-bg-cirrusBlue-25 cr-font-main cr-text-xs cr-transition-colors cr-duration-200 md:cr-text-sm ${rowIndex === 0 ? 'cr-border-t-0' : ''}`}
            >
              {Array.from({ length: columns }).map((_, cellIndex) => {
                let tdClass = 'cr-px-3 cr-py-2';
                if (rowIndex !== rows - 1) tdClass += ' cr-border-b-2 cr-border-cirrusBlue-100 cr-border-solid';
                else tdClass += ' cr-rounded-bl-lg';
                return (
                  <td key={cellIndex} className={tdClass}>
                    <div className="cr-h-4 cr-w-16 cr-animate-pulse cr-rounded cr-bg-gray-200"></div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
